import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { POSTS } from "@/lib/data";

const MotionLink = motion(Link);

export const Resources = () => (
  <section id="resources" data-testid="resources-section" className="bg-bone py-28 lg:py-40">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
        <Reveal>
          <p className="mb-6 flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-clay">
            <span className="h-[1px] w-10 bg-clay" /> The journal
          </p>
          <h2 className="font-serif font-light text-4xl md:text-6xl leading-[1.02] tracking-tight text-[var(--astera-char)]">
            Clear answers, <span className="italic text-clay">honestly written.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <Link
            to={`/journal/${POSTS[0].slug}`}
            data-testid="resources-all-link"
            className="link-underline text-sm uppercase tracking-[0.16em] text-[var(--astera-char)]/80"
          >
            Start reading
          </Link>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        {POSTS.map((p, i) => (
          <Reveal key={p.slug} delay={i * 0.1}>
            <MotionLink
              to={`/journal/${p.slug}`}
              whileHover="hover"
              data-testid={`post-card-${i}`}
              className="group block"
            >
              <div className="relative aspect-square overflow-hidden rounded-[24px]">
                <motion.img
                  variants={{ hover: { scale: 1.06 } }}
                  transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                  src={p.img}
                  alt={p.title}
                  className="h-full w-full object-cover"
                />
                <span className="absolute top-4 left-4 rounded-full bg-bone/90 backdrop-blur px-4 py-1.5 text-[11px] uppercase tracking-[0.14em] text-[var(--astera-char)]">
                  {p.tag}
                </span>
              </div>
              <div className="mt-5 flex items-start justify-between gap-4">
                <h3 className="font-serif text-2xl leading-snug text-[var(--astera-char)]">
                  {p.title}
                </h3>
                <ArrowUpRight
                  size={22}
                  className="mt-1 shrink-0 text-clay transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </div>
              <p className="mt-2 text-xs uppercase tracking-[0.14em] text-[var(--astera-char)]/45">
                {p.read}
              </p>
            </MotionLink>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
